<header mat-dialog-title>
    <div class="sideActions">
        <button class="backAction" mat-icon-button tabindex="-1" (click)="onBackClick()">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
    <div class="title">
        @if (inInsertState) { Cadastro } @if (inEditState) { Edição } @if (inViewState) {
        Visualização } @if (title || shortTitle) { de
        {{ mobile && shortTitle ? shortTitle : title }}
        }
    </div>
    @if (showMenu) {
    <div class="sideActions">
        <mat-menu #appMenu="matMenu">
            @for (action of context.aditionalActions.secondary; track action) { @if (action.rendered
            == null || action.rendered) {
            <button
                mat-menu-item
                [asyncAction]="action.onAction"
                [disabled]="action.disabled != null && action.disabled"
            >
                {{ action.name }}
            </button>
            } } @if (!onlyFullScreen) {
            <button mat-menu-item (click)="toggleMaximize()">
                {{ maximized ? 'Restaurar' : 'Maximizar' }}
            </button>
            } @if (showDelete) {
            <button #deleteBtn mat-menu-item (click)="onDeleteClick()">Excluir</button>
            }
            <button mat-menu-item>Ajuda</button>
        </mat-menu>
        <button mat-icon-button tabindex="-1" [matMenuTriggerFor]="appMenu">
            <mat-icon>more_vert</mat-icon>
        </button>
    </div>
    }
</header>
<mat-dialog-content>
    <div class="form-container">
        <div class="form-content">
            <ng-container
                *ngTemplateOutlet="$safeNavigationMigration(content?.templateRef); context: context"
            ></ng-container>
        </div>
        @if (!showButtonsAsFabs) {
        <div class="custom-actions">
            @if (!entityActive) {
            <button #activateBtn mat-button [asyncAction]="onActivateAction">Ativar</button>
            } @if (entityActive) { @for (action of context.aditionalActions.primary; track action) {
            @if (action.rendered == null || action.rendered) {
            <button
                mat-button
                [asyncAction]="action.onAction"
                [disabled]="action.disabled != null && action.disabled"
            >
                {{ action.name }}
            </button>
            } } @if (showSave) {
            <button #saveBtn mat-button [asyncAction]="onSaveAction" [disabled]="!valid">
                Salvar
            </button>
            }
            <mat-menu #saveMenu="matMenu">
                <button mat-menu-item [asyncAction]="onSaveAndContinueAction" [disabled]="!valid">
                    Salvar e continuar
                </button>
                @if (showSaveAndNew) {
                <button mat-menu-item [asyncAction]="onSaveAndNewAction" [disabled]="!valid">
                    Salvar e novo
                </button>
                }
                <button mat-menu-item [asyncAction]="onSaveAndCloseAction" [disabled]="!valid">
                    Salvar e sair
                </button>
            </mat-menu>
            @if (showSave) {
            <button mat-icon-button [matMenuTriggerFor]="saveMenu" [disabled]="!valid">
                <mat-icon>more_vert</mat-icon>
            </button>
            } @if (showEdit) {
            <button #editBtn mat-button (click)="onEditClick()">Editar</button>
            } }
        </div>
        } @if (showButtonsAsFabs) {
        <section>
            @if (entityActive) { @if (showSave) {
            <button
                #saveBtn
                mat-fab
                [asyncAction]="onSaveAction"
                [disabled]="!valid"
                class="floatDefault"
            >
                <mat-icon>check</mat-icon>
            </button>
            } @if (showEdit) {
            <button #editBtn mat-fab (click)="onEditClick()" class="floatDefault">
                <mat-icon>edit_square</mat-icon>
            </button>
            } }
        </section>
        }
    </div>
</mat-dialog-content>
